var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ViewEstimateUrl, inspectionDetailsGetByIdAPI } from '../../api/url';
import UnsavedChangesPopup from '../../components/molecules/unsavedChangesPopup';
import { APISchema, EMenuNames, EParentModuleName, ESystemName, StatusEnum } from '../../constants';
import { getDocumentByIdAPIFunction, showLoader } from '../../redux/commonSlice';
import { getByIdAPI } from '../../redux/crudSlice';
import { useAppDispatch } from '../../store/hooks';
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
import { scrollToTop } from '../../utils/utils';
import EditDocumentIndex from '../commonViews/editDocumentFlow.tsx/editDocument.index';
export default function InspectionDetailsComponent() {
    var _this = this;
    var trackButtonClick = useAnalyticsEventTracker("InspectionDetailsComponent");
    var documentId = useParams().documentId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _a = useState(false), openPopup = _a[0], setOpenPopup = _a[1];
    var isDocDataUpdated = useSelector(function (state) { return state.common; }).isDocDataUpdated;
    var _b = useState(true), isShowSkeleton = _b[0], setShowSkeleton = _b[1];
    var _c = useState(), estResponse = _c[0], setEstimateResponse = _c[1];
    var _d = useState(false), disableState = _d[0], setDisableState = _d[1];
    var state = useLocation().state;
    useEffect(function () {
        scrollToTop();
        initialVehicleInspectionDetails();
    }, []);
    var initialVehicleInspectionDetails = function () { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload, _result$payload2, result, _result$payload3, _result$payload4, isDisabled, _estimateResponse$pay, _estimateResponse$pay2, _estimateResponse$pay3, requestBody, _estimateResponse, _estimateResponse$pay4, _estimateResponse$pay5, _estimateResponse$pay6, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, dispatch(getDocumentByIdAPIFunction({
                            key: 'documentDetailsGetById',
                            url: "".concat(inspectionDetailsGetByIdAPI).concat(documentId, "/Get")
                        }))];
                case 1:
                    result = _a.sent();
                    if (!((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 || (_result$payload = _result$payload.value) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.success)) return [3 /*break*/, 4];
                    setShowSkeleton(false);
                    isDisabled = [StatusEnum.Converted, StatusEnum.Cancelled, StatusEnum.Closed].includes((result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.data) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.Key) || "");
                    if (!((result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.Key) === StatusEnum.Converted)) return [3 /*break*/, 3];
                    requestBody = {
                        "PreJobCardDocumentId": documentId,
                        "HasChild": true
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'getParentDocumentId',
                            url: ViewEstimateUrl,
                            request: requestBody
                        }))];
                case 2:
                    _estimateResponse = _a.sent();
                    if (_estimateResponse !== null && _estimateResponse !== void 0 && (_estimateResponse$pay = _estimateResponse.payload) !== null && _estimateResponse$pay !== void 0 && (_estimateResponse$pay = _estimateResponse$pay.value) !== null && _estimateResponse$pay !== void 0 && (_estimateResponse$pay = _estimateResponse$pay.data) !== null && _estimateResponse$pay !== void 0 && _estimateResponse$pay.PreJobCardDocumentId && _estimateResponse !== null && _estimateResponse !== void 0 && (_estimateResponse$pay2 = _estimateResponse.payload) !== null && _estimateResponse$pay2 !== void 0 && (_estimateResponse$pay2 = _estimateResponse$pay2.value) !== null && _estimateResponse$pay2 !== void 0 && _estimateResponse$pay2.success && (_estimateResponse === null || _estimateResponse === void 0 || (_estimateResponse$pay3 = _estimateResponse.payload) === null || _estimateResponse$pay3 === void 0 || (_estimateResponse$pay3 = _estimateResponse$pay3.value) === null || _estimateResponse$pay3 === void 0 ? void 0 : _estimateResponse$pay3.statusCode) == 200) {
                        setEstimateResponse(_estimateResponse);
                        if ((_estimateResponse === null || _estimateResponse === void 0 || (_estimateResponse$pay4 = _estimateResponse.payload) === null || _estimateResponse$pay4 === void 0 || (_estimateResponse$pay4 = _estimateResponse$pay4.value) === null || _estimateResponse$pay4 === void 0 || (_estimateResponse$pay4 = _estimateResponse$pay4.data) === null || _estimateResponse$pay4 === void 0 ? void 0 : _estimateResponse$pay4.Key) === StatusEnum.ApprovalPending || (_estimateResponse === null || _estimateResponse === void 0 || (_estimateResponse$pay5 = _estimateResponse.payload) === null || _estimateResponse$pay5 === void 0 || (_estimateResponse$pay5 = _estimateResponse$pay5.value) === null || _estimateResponse$pay5 === void 0 || (_estimateResponse$pay5 = _estimateResponse$pay5.data) === null || _estimateResponse$pay5 === void 0 ? void 0 : _estimateResponse$pay5.Key) === StatusEnum.Created || (_estimateResponse === null || _estimateResponse === void 0 || (_estimateResponse$pay6 = _estimateResponse.payload) === null || _estimateResponse$pay6 === void 0 || (_estimateResponse$pay6 = _estimateResponse$pay6.value) === null || _estimateResponse$pay6 === void 0 || (_estimateResponse$pay6 = _estimateResponse$pay6.data) === null || _estimateResponse$pay6 === void 0 ? void 0 : _estimateResponse$pay6.Key) === StatusEnum.Error) {
                            isDisabled = false;
                        }
                        else {
                            isDisabled = true;
                        }
                    }
                    _a.label = 3;
                case 3:
                    setDisableState(isDisabled);
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.log("Error-", e_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleHeaderClick = function () {
        trackButtonClick("ButtonClickEvent", "On_Back_Click_InsepectionDetails", undefined);
        if (isDocDataUpdated) {
            setOpenPopup(true);
        }
        else {
            if (state !== null && state !== void 0 && state.fromRoute) {
                navigate(state === null || state === void 0 ? void 0 : state.fromRoute);
            }
            else {
                navigate("/inspection");
            }
        }
    };
    var onClickYesBtn = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            trackButtonClick("ButtonClickEvent", "On_Yes_Click_InsepectionDetails", undefined);
            setOpenPopup(false);
            return [2 /*return*/];
        });
    }); };
    var onClickNoBtn = function () {
        trackButtonClick("ButtonClickEvent", "On_Nos_Click_InsepectionDetails", undefined);
        navigate('/inspection');
    };
    var handleMoreClick = function () {
        console.log("API calling...");
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditDocumentIndex, {
        moduleName: EMenuNames.Inspection,
        SystemName: ESystemName.Inspection,
        parentComponent: EParentModuleName.Inspection,
        APISchema: APISchema.Inspection,
        documentId: documentId !== null && documentId !== void 0 ? documentId : '',
        apiRequestPayload: {
            InspectionId: documentId !== null && documentId !== void 0 ? documentId : ''
        },
        handleHeaderClick: function () { return handleHeaderClick(); },
        handleMoreIconClick: function () { return console.log("second"); },
        isDisabled: disableState,
        modifyDocumentURL: "".concat(inspectionDetailsGetByIdAPI).concat(documentId, "/ModifyInspection"),
        createAndEditFlow: {
            isInspection: "Update"
        },
        onMoreIconClick: function () { return handleMoreClick(); },
        isShowSkeleton: isShowSkeleton,
        headerTitle: t("Job card"),
        estResponse: estResponse
    }), /*#__PURE__*/ React.createElement(UnsavedChangesPopup, {
        isOpen: openPopup,
        onClosePopup: function (value) { return setOpenPopup(value); },
        onClickNoBtn: onClickNoBtn,
        onClickYesBtn: onClickYesBtn
    }));
}
